@let blok = block();

<div [ngClass]="getOuterClasses()" class="outer-icon-list-element-div inline-grid gap-x-6 gap-y-2">
    <div class="col-start-1 col-end-2 min-w-16">
        @for (child of blok.children; track child['_uid']) {
            <s1-cms-component [blok]="child"/>
        }</div>
    <div class="flex items-center">
        @switch (blok.level ? +blok.level : 1) {
            @case (2) {
                <h2 class="col-start-2 col-end-3 text-xl text-left font-bold">
                    {{ blok.headingTextContent }}
                </h2>
            }
            @case (3) {
                <h3 class="col-start-2 col-end-3 text-xl text-left font-bold">
                    {{ blok.headingTextContent }}
                </h3>
            }
            @case (4) {
                <h4 class="col-start-2 col-end-3 text-xl text-left font-bold">
                    {{ blok.headingTextContent }}
                </h4>
            }
            @case (5) {
                <h5 class="col-start-2 col-end-3 text-xl text-left font-bold">
                    {{ blok.headingTextContent }}
                </h5>
            }
            @case (6) {
                <h6 class="col-start-2 col-end-3 text-xl text-left font-bold">
                    {{ blok.headingTextContent }}
                </h6>
            }
            @default {
                <h1 class="col-start-2 col-end-3 text-xl text-left font-bold">
                    {{ blok.headingTextContent }}
                </h1>
            }
        }
    </div>
    <p class="row-start-2 row-end-3 col-start-2 col-end-3 text-base">
        {{ blok.paragraphTextContent }}
    </p>
</div>
